import React from 'react'
import styled from 'styled-components'
import White from '../white'
import Text from '../text'
import Portable from '../portable'

const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
`

const Container = styled.div`
  background-color: #fff;
`

const Section = ({module}) => {

  const { heading, body, hide_hr } = module

  return (
    <Container>
    <White>
      <Text align="left">
      { heading &&
        <h2>{heading}</h2>
      }
      { body &&
        <Inner className="narrow">
          <Portable blocks={body} />
        </Inner>
      }
      </Text>
    </White>
    { !hide_hr &&
      <hr />
    }
    </Container>
  )
}

export default Section
